import {
  useLocation,
  useParams,
  useOutletContext,
  Link,
} from "react-router-dom";
import { useEffect, useState, useRef, useCallback } from "react";
import { useTranslation } from "react-i18next";
import DashboardHeader from "../components/Other/DashboardHeader";
import PageHeaderTitle from "../components/pages/PageHeaderTitle";
import PageContainer from "../components/pages/PageContainer";
import { addStockToWatchlists, createWatchlist, deleteWatchlistItem, deleteWatchlists, getUserDefaultWatchlist, getUserWatchlists, getWatchlistItems, getWatchlistsSearchPage, setUserDefaultWatchlist } from "../api/user";
import { useNavigate } from 'react-router-dom';
import usePullToRefresh from "../hooks/usePullToRefresh";
import PullToRefreshIndicator from "../components/Other/PullToRefreshIndicator";

import { toast } from "react-toastify";
import SearchBar1 from "./SearchBar1";
import { IconLeftBold, IconPlusCircle } from "../icons/icons";
import ListSkeleton from "../components/Skeleton/ListSkeleton";



const MobileWatchlistPage = () => {
  const { id } = useParams();
  const location = useLocation();
  const { name, isSystemWatchlist} = location.state || {};

  const fromChart1 = location.state?.fromChart1 ?? false;
  const fromChart = localStorage.getItem('fromChart') === 'true';

  // alert(fromChart1);
  // alert(fromChart);

  const [sidebarToggle] = useOutletContext();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);
const [searchResults, setSearchResults] = useState([]);
const [watchlistName, setWatchlistName] = useState("");
const [showModal, setShowModal] = useState(false);
const [createLoading,setCreateLoading] = useState(false);
const loadMoreRef = useRef(null);


  const [childWatchlists, setChildWatchlists] = useState([]);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  const [deleteMode, setDeleteMode] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);

  const [activeWatchlistId, setActiveWatchlistId] = useState(null);
  const [showAddModal, setShowAddModal] = useState(false);
  const [addOptions, setAddOptions] = useState([]);
  const [loadingOptions, setLoadingOptions] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [loadingDeleteOptions, setLoadingDeleteOptions] = useState(false);
  const [selectedDeleteWatchlists, setSelectedDeleteWatchlists] = useState([]);
  const [deleteOptions, setDeleteOptions] = useState([]);
  const [settingWatchlistId, setSettingWatchlistId] = useState(null);
  const [userDefaultWatchlistId, setUserDefaultWatchlistId] = useState(null);
  const { containerProps, isRefreshing, pullDistance } = usePullToRefresh({
    onRefresh: () => loadItems(id, true),
    disabled: false,
  });

  useEffect(() => {
    const fetchDefaultWatchlist = async () => {
      try {
        const res = await getUserDefaultWatchlist();
        setUserDefaultWatchlistId(res.data.default_watchlist_id);
      } catch (error) {
        console.error("Failed to fetch default watchlist", error);
      }
    };
    fetchDefaultWatchlist();
  }, []);

  function getColorForId(id) {
    const colors = ["#35b23c", "#004c50", "#006565"];
    return colors[id % colors.length];
  }

  // helper to detect direct type parents (1,2,3)
  const isDirectType = (pid) => [1, 2, 3].includes(Number(pid));

  // Fetch child watchlists for parent id (used for parent types not direct)
  const fetchChildWatchlists = async (parentId) => {
    try {
      setLoading(true);
      const res = await getWatchlistsSearchPage(parentId);
      const list = Array.isArray(res.data.watchlists) ? res.data.watchlists : [];
      setChildWatchlists(list);
    } catch (err) {
      console.error("Error fetching child watchlists:", err);
      setChildWatchlists([]);
    } finally {
      setLoading(false);
    }
  };

  // Fetch items for a given watchlist id or default key
const loadItems = async (idOrKey, reset = false) => {
  try {
    setLoading(true);

    const currentPage = reset ? 1 : page; // reset page if needed
    const response = await getWatchlistItems(idOrKey, currentPage, 3);
    const fetchedItems = response?.data?.items;

    if (Array.isArray(fetchedItems)) {
      setItems((prevItems) =>
        reset ? fetchedItems : [...prevItems, ...fetchedItems]
      );
      setPage(currentPage + 1);
      setHasMore(response?.data?.pagination?.has_more || false);
    }
  } catch (err) {
    console.error("Error fetching watchlist items:", err);
    setItems([]);
  } finally {
    setLoading(false);
  }
};



const handleSelectAll = (e) => {
  if (e.target.checked) {
    setSelectedOptions(addOptions.map((opt) => opt.id));
  } else {
    setSelectedOptions([]);
  }
};

const handleOptionChange = (id) => {
  setSelectedOptions((prev) =>
    prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
  );
};


useEffect(() => {
  if (!fromChart1) {
    localStorage.removeItem('fromChart');
  }
}, [fromChart1]);

  // When id changes, decide what to do
  useEffect(() => {
    if (!id) return;

    if (isDirectType(id)) {
      // For parent = 1,2,3 → use default keys
      const mapping = { 1: "stocks", 2: "forex", 3: "crypto" };
      const defKey = mapping[Number(id)];
      setChildWatchlists([]);  // no child in this route
      setActiveWatchlistId(defKey); // mark active
      loadItems(defKey);
    } else {
      // For parent 4,5 etc → fetch child watchlists
      fetchChildWatchlists(Number(id));
      setItems([]);  // clear any old items
      setActiveWatchlistId(null);
    }
  }, [id]);

useEffect(() => {
  const fetchOptions = async () => {
    try {
      setLoadingOptions(true);
      const res = await getUserWatchlists();
      if (res?.data?.watchlists) {
        setAddOptions(res.data.watchlists);
      } else {
        toast.error("No options found");
        setAddOptions([]);
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to fetch options");
      setAddOptions([]);
    } finally {
      setLoadingOptions(false);
    }
  };

  if (showAddModal) fetchOptions();
}, [showAddModal]);

  useEffect(() => {
  const fetchDeleteOptions = async () => {
    try {
      setLoadingDeleteOptions(true);
      const res = await getUserWatchlists();
      if (res?.data?.watchlists) {
        setDeleteOptions(res.data.watchlists);
      } else {
        toast.error("No watchlists found");
        setDeleteOptions([]);
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to fetch watchlists");
      setDeleteOptions([]);
    } finally {
      setLoadingDeleteOptions(false);
    }
  };

  if (showDeleteModal) {
    fetchDeleteOptions();
  }
  }, [showDeleteModal]);

  useEffect(() => {
  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting && hasMore && !loading) {
        // Trigger loading of more items
        loadItems(activeWatchlistId);
      }
    },
    {
      rootMargin: '100px', // Trigger when 100px from the bottom
    }
  );

  if (loadMoreRef.current) {
    observer.observe(loadMoreRef.current);
  }

  return () => {
    if (loadMoreRef.current) {
      observer.unobserve(loadMoreRef.current);
    }
  };
}, [hasMore, loading, activeWatchlistId]);


  const handleCreate = async () => {
    if (!watchlistName) return alert("Please enter a name");

    setCreateLoading(true);
    try {
      await createWatchlist({ name: watchlistName });
      setShowModal(false);
      setWatchlistName("");// refresh list after create
      toast.success("Watchlist created successfully!");
      fetchChildWatchlists(Number(id));
    } catch (err) {
      console.error("Error creating watchlist", err);
      toast.error("Failed to create watchlist");
    } finally {
      setCreateLoading(false);
    }
  };

const handleCategoryChange = async (newCategory) => {
  // Clear everything before reloading
  setItems([]);
  setPage(1);
  setHasMore(true);
  setActiveWatchlistId(newCategory);

  await loadItems(newCategory, true); // reset = true
};


  const handleMobileDefaultWatchlist = async (watchlistId) => {
    // already default → do nothing
    if (String(userDefaultWatchlistId) === String(watchlistId)) {
      return;
    }

    try {
      setSettingWatchlistId(watchlistId);

      await setUserDefaultWatchlist({
        default_watchlist_id: watchlistId,
      });

      setUserDefaultWatchlistId(watchlistId);

      toast.success("Default watchlist set successfully ✅");
    } catch (error) {
      console.error("Failed to set default watchlist", error);

      toast.error(
        error?.response?.data?.message ||
        "Failed to set default watchlist ❌"
      );
    } finally {
      setSettingWatchlistId(null);
    }
  };


  return (
    <>
      <DashboardHeader toggle={sidebarToggle} searchVal1={name}/>
      <PageHeaderTitle title={name || "The Must Watch"} />
      <PageContainer>
        <div className="space-y-2 mt-2" {...containerProps}>
          <PullToRefreshIndicator pullDistance={pullDistance} isRefreshing={isRefreshing} />

          {/* Heading section — show always when direct or after child */}
          { (isDirectType(id)) && (
              <SearchBar1
                onResults={setSearchResults}
                onCategoryChange={handleCategoryChange} // same function you already use
                name={name}
              />

          )}

          {Number(id) !== 5 && !fromChart && (
            <div className="grid grid-cols-2 gap-2 items-center">
              <button
                onClick={() => setShowModal(true)}
                className="text-center bg-[#f8f9f9] gap-2 px-4 py-3 rounded"
              >
                Create Watchlist
              </button>

              <button
                onClick={() => setShowDeleteModal(true)}
                className="text-center bg-[#f8f9f9] gap-2 px-4 py-3 rounded"
              >
                Delete Watchlist
              </button>
            </div>
          )}

                {searchResults.length > 0 && (
                  <div className="space-y-2">
                    {searchResults.map((item, i) => (
                                <div class="flex flex-row items-center justify-between w-full gap-4 bg-[#f8f9f9] p-3 rounded-md">
                                  <div class="grid grid-cols-[auto_1fr] gap-5 items-center text-base w-full overflow-hidden overflow-ellipsis whitespace-nowrap"  onClick={() => {
                                    // Set ticker in localStorage so chart page shows correct stock in scroller
                                    localStorage.setItem("ticker", item.ticker);
                                    navigate(`/chartSearch/${item.ticker}`);
                                  }}
 >
                                    <div
                                      class="mx-auto max-sm:p-1.5 flex h-[83px] items-center justify-center sm:px-5 rounded-[41px] md:text-[16px] text-[10px] text-center text-white-A700 w-[83px] bg-primaryColor"  >
                                      <span class="text-white max-sm:break-all leading-normal text-[13.5px]">
                                        {item.ticker}
                                      </span>
                                    </div>
                                    <div >
                                      <div
                                        class="text-lg text-black whitespace-normal font-montserrat"  >
                                        {item.name}
                                      </div>
                                    </div>
                                  </div>
                                  <div class="text-right w-auto text-base md:w-full overflow-hidden overflow-ellipsis whitespace-nowrap" >
                                    <div class="text-primaryColor font-bold">
                                        <button
                                          onClick={() => {
                                            setSelectedItem(item);
                                            setShowAddModal(true);
                                          }}
                                          className="px-3 py-1 grayscale hover:grayscale-0"
                                        >
                                          {IconPlusCircle}
                                        </button>
                                    </div>
                                  </div>
                                </div>
                    ))}
                  </div>
                )}


          {/* If parent is not direct and we have child list, show children */}
          {!isDirectType(id) &&
            !activeWatchlistId &&
            childWatchlists.length > 0 && (
              <div className="space-y-2">
                {childWatchlists.map((c) => (
                  <ul key={c.id}>
                    <li
                      style={{ backgroundColor: getColorForId(c.id) }}
                      className="relative flex items-center justify-center cursor-pointer outline-offset-2 outline md:rounded rounded-lg px-4 xl:h-[110px] h-[90px] max-md:border-2 border-black text-center text-2xl font-bold text-white transition-all duration-300 ease-in-out"
                      onClick={() => {
                        navigate(`/mobile-children-watchlist/${c.id}`, {
                          state: {
                            is_system: c.is_system,
                            name: name,
                            childName: c.name,
                          },
                        });
                      }}
                    >
                      {/* ✅ Checkbox (top-right corner) */}
                      <div
                        className="absolute top-2 right-2 z-10"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <input
                          type="checkbox"
                          style={{ accentColor: '#004C50' }}
                          checked={
                            String(userDefaultWatchlistId) === String(c.id)
                          }
                          disabled={settingWatchlistId === c.id}
                          onChange={() => handleMobileDefaultWatchlist(c.id)}
                        />

                        {settingWatchlistId === c.id && (
                          <span className="ml-1 text-xs">...</span>
                        )}
                      </div>

                      {/* Watchlist Name */}
                      <div>{c.name}</div>
                    </li>
                  </ul>
                ))}
              </div>
            )}


          {/* Show items when activeWatchlistId is set */}
        {activeWatchlistId && searchResults.length === 0 && (
          <>
          <div className="grid gap-3 mt-4">
            {!loading && items.length === 0 && (
              <div className="text-center py-8 text-gray-500">
                No items found
              </div>
            )}
            {items.map((item) => (
              <Link
                key={item.id}
                to={`/chartSearch/${item.is_system && item.etf ? item.etf : item.symbol}`}
                className="relative bg-white block p-4 rounded hover:bg-primaryColor/10"
                onClick={() => {
                  // Set ticker in localStorage so chart page shows correct stock in scroller
                  const tickerSymbol = item.is_system && item.etf ? item.etf : item.symbol;
                  localStorage.setItem("ticker", tickerSymbol);
                }}
              >
                <div className="flex flex-col w-full">
                  <div className="flex items-center justify-between gap-4">
                    <div className="grid grid-cols-[auto_1fr] gap-5 items-center text-base w-full overflow-hidden whitespace-nowrap">
                      {/* <div className="mx-auto max-sm:p-1.5 flex h-[83px] items-center justify-center sm:px-5 rounded-[41px] bg-primaryColor text-white text-[13.5px] w-[83px]">
                        {item.watchlist_name}
                      </div> */}
                              <img
                                className="h-20 w-20 object-contain"
                                height={83}
                                width={83}
                                src={item?.logo || "/bitcoin.png"}
                                alt="logo"
                              />
                      <div>
                        <div className="text-lg text-black whitespace-normal font-montserrat">
                          {item.details?.stock_name || "N/A"}
                        </div>
                      </div>
                    </div>

                    {/* <div
                      className={`items-center text-base w-full justify-center ${
                        item.details?.percentageChange < 0 ? "text-red-500" : "text-green-500"
                      }`}
                      style={{ maxWidth: "100px" }}
                    >
                      <div
                        className={`md:text-center text-end overflow-hidden whitespace-nowrap w-full ${
                          item.details?.percentageChange < 0 ? "text-red-500" : "text-green-500"
                        }`}
                        style={{ maxWidth: "100px" }}
                      >
                        $
                        {Number(item.details?.latestData?.c || 0).toLocaleString("en-US", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </div>
                      <div className="flex justify-end items-center gap-1 md:text-center font-semibold text-base">
                        <img
                          src={item.details?.percentageChange < 0 ? "/red-down.png" : "/green-up.png"}
                          width={16}
                          alt="trend"
                        />
                        {Math.abs(item.details?.percentageChange || 0).toFixed(2)}%
                      </div>
                    </div> */}

                    <div class="text-primaryColor font-bold">
                                                                              <button
                                                                                onClick={(e) => {
                                                                                  e.preventDefault();
                                                                                  e.stopPropagation();
                                                                                  setSelectedItem(item);
                                                                                  setShowAddModal(true);
                                                                                }}
                                                                                className="px-3 py-1 grayscale hover:grayscale-0"
                                                                              >
                                                                                {IconPlusCircle}
                                                                              </button>
                   </div>
                  </div>
                </div>
              </Link>

            ))}
          </div>
          <div ref={loadMoreRef} />
          </>
        )}


          {loading && (
            <ListSkeleton
              rows={3}
              avatarSize={36}
              columns={2}
              columnWidths={[70, 56]}
              rowClassName="py-3.5"
            />
          )}
          {!loading && !items.length === 0 && !hasMore && <div className="text-center py-4 text-gray-500">No more items</div>}


          {showAddModal && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
              <div className="bg-white p-6 rounded-lg shadow-lg w-80 text-center">
                <h3 className="text-lg font-semibold mb-4">Add</h3>

                <p className="mb-4 text-gray-700">
                  {selectedItem
                    ? `${selectedItem.ticker || selectedItem.details.stock_symbol} (${selectedItem.name || selectedItem.details.stock_name})`
                    : ""}
                </p>

                {/* 🔹 Watchlist options */}
                {loadingOptions ? (
                  <p className="text-gray-500 mb-4">Loading options...</p>
                ) : (
                  <div className="space-y-3 mb-4 text-left">
                    {addOptions.length > 0 ? (
                      addOptions.map((option) => (
                        <div
                          key={option.id}
                          onClick={async () => {
                            if (!selectedItem) return;
                            try {
                              const res = await addStockToWatchlists(
                                selectedItem.ticker || selectedItem.details.stock_symbol,
                                [option.id] // add to one watchlist directly
                              );
                              if (res.status === 200) {
                                toast.success(
                                  `Added to "${option.name}" successfully!`
                                );
                                setShowAddModal(false);
                              } else {
                                toast.error("Failed to add stock.");
                              }
                            } catch (err) {
                              console.error(err);
                              toast.error("Error adding stock.");
                            }
                          }}
                          style={{
                            backgroundColor: getColorForId(option.id),
                          }}
                          className="cursor-pointer border rounded-lg px-3 py-3 text-white text-center transition-transform duration-200 hover:scale-[1.03] hover:shadow"
                        >
                          {option.name}
                        </div>
                      ))
                    ) : (
                      <p className="text-gray-500">No watchlists found.</p>
                    )}
                  </div>
                )}

                {/* 🔹 Cancel button */}
                <div className="flex justify-center">
                  <button
                    onClick={() => {
                      setShowAddModal(false);
                    }}
                    className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          )}


        {showModal && (
                    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40">
                      <div className="bg-white rounded p-6 w-96">
                        <h3 className="text-lg font-bold mb-4">
                          Create Watchlist
                        </h3>

                        <input
                          type="text"
                          value={watchlistName}
                          onChange={(e) => setWatchlistName(e.target.value)}
                          placeholder="Enter watchlist name"
                          className="w-full border px-3 py-2 mb-4 rounded"
                        />

                        <div className="flex justify-end space-x-2">
                          <button
                            onClick={() => setShowModal(false)}
                            className="px-4 py-2 border rounded"
                            disabled={loading}
                          >
                            Cancel
                          </button>
                          <button
                            onClick={handleCreate}
                            className="px-4 py-2 bg-primaryColor text-white rounded"
                            disabled={loading}
                          >
                            {createLoading ? "Creating..." : "Create"}
                          </button>
                        </div>
                      </div>
                    </div>
        )}

        {showDeleteModal && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-white p-6 rounded-lg shadow-lg w-80 text-center">
              <h3 className="text-lg font-semibold mb-4">Delete Watchlist</h3>

              {loadingDeleteOptions ? (
                <p className="text-gray-500 mb-4">Loading watchlists...</p>
              ) : (
                <div className="space-y-3 mb-4 text-left">
                  {deleteOptions.length > 0 ? (
                    deleteOptions.map((option) => (
                      <div
                        key={option.id}
                        onClick={async () => {
                          try {
                            const res = await deleteWatchlists([option.id]); // delete one
                            if (res.status === 200) {
                              toast.success(`"${option.name}" deleted successfully!`);
                              setShowDeleteModal(false);
                              setSelectedDeleteWatchlists([]);
                              fetchChildWatchlists(Number(id)); // refresh list
                            } else {
                              toast.error("Failed to delete watchlist.");
                            }
                          } catch (err) {
                            console.error(err);
                            toast.error("Error deleting watchlist.");
                          }
                        }}
                        style={{
                          backgroundColor: getColorForId(option.id),
                        }}
                        className="cursor-pointer border rounded-lg px-3 py-3 text-white text-center transition-transform duration-200 hover:scale-[1.03] hover:shadow"
                      >
                        {option.name}
                      </div>
                    ))
                  ) : (
                    <p className="text-gray-500">No watchlists available.</p>
                  )}
                </div>
              )}

              {/* 🔹 Cancel button */}
              <div className="flex justify-center">
                <button
                  onClick={() => {
                    setShowDeleteModal(false);
                    setSelectedDeleteWatchlists([]);
                  }}
                  className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}




        </div>
      </PageContainer>
    </>
  );
};

export default MobileWatchlistPage;



